import React from "react";
import { Modal, Button } from "react-bootstrap";
import axios from "axios";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import api from "../../api.js";

const DeleteConfirmModal = ({ show, onClose, field }) => {
  const token = Cookies.get("access_token");
  const navigate = useNavigate();

  const handleDelete = async () => {
    try {
      await api.delete(`/field/${field.id}/`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      onClose(); // Close the modal
      navigate("/home"); // Redirect
    } catch (err) {
      console.error("Delete failed:", err);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton className="bg-danger text-white">
      </Modal.Header>

      <Modal.Body>
        <p className="mb-0">
          آیا مطمئن هستید که می‌خواهید این مورد را حذف کنید؟ این عملیات
          قابل بازگشت نیست.
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Button className="btn-edit" variant="secondary" onClick={onClose}>
          لغو
        </Button>
        <Button variant="danger" onClick={handleDelete} id="confirmDelete">
          حذف
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteConfirmModal;
